module.exports = __webpack_public_path__ + "static/media/trash.36e1a132.svg";